export default __webpack_public_path__ + "static/allred-c4183f2dbbe027ca3c737c479ec7323b.jpg";